import { useState, useEffect } from 'react'
import defaults from '@config/defaults'

const useDebounce = (value, delay = defaults.debounceInputDelay) => {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    return () => { clearTimeout(handler) }
  }, [value])
  return debouncedValue
}

export default useDebounce
